import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {JORNADA_SERVICOS_ONLINE, SOLICITACAO_AUTORIZACAO} from './autorizacao-api';
import {map} from 'rxjs/operators';
import { Beneficiario } from '../shared/models/beneficiario.model';
import { BusinessService } from './business.service';

@Injectable({
  providedIn: 'root'
})

export class BeneficiarioService {

  url: string = SOLICITACAO_AUTORIZACAO;
  urlJornada: string = JORNADA_SERVICOS_ONLINE;

  constructor(private http: HttpClient, private router: Router,  private businessService: BusinessService) {
  }

  buscaBeneficiarios(cdPessoa: string): Observable<any> {
    let params = new HttpParams();
    var cdEmpresa = (this.businessService.getBusinessId()) ? this.businessService.getBusinessId() : '1';

    params = params.append('cdPessoa', cdPessoa);
    params = params.append('cdEmpresa', cdEmpresa);

    let httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };

    return this.http.get(this.url + '/beneficiario/listaBeneficiarios', httpOptions)
      .pipe(map(beneficiarios => beneficiarios));
  }

  validaRedeAtendimento(beneficiario: Beneficiario): Observable<any> {
    return this.http.get(this.url + `/beneficiario/rede?cdUsuario=${beneficiario.cdUsuario}&cdFilial=${beneficiario.cdFilial}&cdRede=${beneficiario.cdTipoRede}`)
    .pipe(map(mensagem => mensagem));
  }

  verificaAutoWeb(cdUsuario: string): Observable<any> {
    var cdEmpresa = (this.businessService.getBusinessId()) ? this.businessService.getBusinessId() : '1';
    return this.http.get(this.url + `/beneficiario/verificaAutoWeb?cdUsuario=${cdUsuario}&cdEmpresa=${cdEmpresa}`)
    .pipe(map(mensagem => mensagem));
  }

  verificaArqWeb(cdUsuario: string, nmArquivo: string): Observable<any> {
    var cdEmpresa = (this.businessService.getBusinessId()) ? this.businessService.getBusinessId() : '1';
    return this.http.get(this.url + `/beneficiario/verificaArqWeb?cdUsuario=${cdUsuario}&nmArquivo=${nmArquivo}&cdEmpresa=${cdEmpresa}`)
    .pipe(map(mensagem => mensagem));
  }

  imprimirGuia(cdSenha: string, cdPrestador: string): Observable<any> {
    var cdEmpresa = (this.businessService.getBusinessId()) ? this.businessService.getBusinessId() : '1';
    return this.http.get(this.url + `/beneficiario/imprimirGuia?cdSenha=${cdSenha}&cdEmpresa=${cdEmpresa}&cdPrestador=${cdPrestador}`)
    .pipe(map(mensagem => mensagem));
  }

  /**
   * Validação e atualização do celular
   * Foi solicitado a retirada da validação e atualização do celular por: Carlos Alberto e Leonardo.
   */
  /*validacaoCelular(cdPessoa: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('cdPessoa', cdPessoa);

    let httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };

    return this.http.get(this.urlJornada + '/beneficiario/sms/token', httpOptions)
      .pipe(map(res => res));
  }

  enviarToken(cdPessoa: string, nuCelular: string, nmAplicativo: string) {
    let params = new HttpParams();
    params = params.append('cdPessoa', cdPessoa).append('nuCelular', nuCelular).append('nmAplicativo', nmAplicativo);

    let httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };

    return this.http.post(this.urlJornada + '/beneficiario/sms/token', null, httpOptions)
      .pipe(map(res => res));
  }

  validarToken(cdPessoa: string, cdToken: string) {
    let params = new HttpParams();
    params = params.append('cdPessoa', cdPessoa).append('cdToken', cdToken);

    let httpOptions: Object = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };

    return this.http.get(this.urlJornada + '/beneficiario/sms/token/validar', httpOptions)
      .pipe(map(res => res));
  }

  reenviarToken(cdPessoa: string) {
    let params = new HttpParams();
    params = params.append('cdPessoa', cdPessoa);

    let httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };

    return this.http.post(this.urlJornada + '/beneficiario/sms/token/reenviar', null, httpOptions)
      .pipe(map(res => res));
  }*/
}
